import { render, staticRenderFns } from "./ProofOfDeliveryTemplateListPage.vue?vue&type=template&id=72ceee0b&scoped=true&"
import script from "./ProofOfDeliveryTemplateListPage.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryTemplateListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryTemplateListPage.vue?vue&type=style&index=0&id=72ceee0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ceee0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ceee0b')) {
      api.createRecord('72ceee0b', component.options)
    } else {
      api.reload('72ceee0b', component.options)
    }
    module.hot.accept("./ProofOfDeliveryTemplateListPage.vue?vue&type=template&id=72ceee0b&scoped=true&", function () {
      api.rerender('72ceee0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplateListPage.vue"
export default component.exports